import React, { useEffect, useState } from "react";
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import TenderCard from '../../components/TenderCards/TenderCard'
import DashboardTable from '../../components/DashboardTable/DashboardTable'
import DashboardHeader from "../../components/DashboardHeader/DashboardHeader";
import { 
  DashboardContainer
} from './DashboardPage.styles';
import { 
  fetchTenders,
  fetchDashboardData,
} from "../../api/api";

export default function DashboardPage(){ 
      const [tableData, setTableData] = useState([]);
      const [dashboardData, setDashboardData] = useState({});
  
      const getTenders = async () => {
          const tenders = await fetchTenders({});
          setTableData(tenders.payload.tenders);
      };

      const getDashboardData = async () => {
        const dashboardDataResults = await fetchDashboardData();
        setDashboardData(dashboardDataResults);
      };

      useEffect(() => {
          getTenders();
      }, []);

      useEffect(() => {
        getDashboardData();
      }, []);

  return(
    <DashboardContainer data-testid="main-content">
      <Breadcrumbs />
      <TenderCard data={dashboardData} />
      <DashboardHeader />
      <DashboardTable tenders={tableData} paginationActive={false} sortingActive={false} maxRows={4} />
    </DashboardContainer>
  );
}